import fetcher from 'api/fetcher';
import axios from 'axios';
import { MagritteNotificationName } from 'utils/constants/notification';

import { urlParser } from '@hh.ru/browser-api-utils';

import { setBanners } from 'store/models/banners';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

export const updateBannerStatus =
    (bannerId: number, enabled: boolean, abortSignal?: AbortSignal): AppThunkAction<Promise<void>> =>
    (dispatch, getState) => {
        const queryStr = urlParser.stringify({
            bannerId,
            enabled: String(!enabled),
        });

        return fetcher
            .put(`/api/v1/banners/${bannerId}/status?${queryStr}`, undefined, { signal: abortSignal })
            .then(() => {
                const banners = getState().banners.banners.map((banner) =>
                    banner.id === bannerId ? { ...banner, enabled: !enabled } : banner
                );

                dispatch(setBanners(banners));
            })
            .catch((error) => {
                if (axios.isCancel(error) || abortSignal?.aborted) {
                    return;
                }

                dispatch(addMagritteNotification(MagritteNotificationName.SomethingWentWrong));
            });
    };
